import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_roen_12: FaireProductEntity = {
  token: "legacy_prod_roen-12",
  type: "product",
  name: "Saint Malo",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/03035e83a0ff7896acb0db08b884b710a5d82dd9c0c7dc048751517483c3c457.webp",
  priceDollars: 18,
  msrpDollars: 36,
  freeShipping: true,
  brandAvatarUrl: "/images/ROEN/Brand%20Page/roen-avatar.webp",
  weight: 0.5,
  dimensions: {
    width: 3,
    height: 4,
    depth: 2,
  },
  brandToken: "catalog_brand_roen",
  description: "Premium candle from ROEN.",
  categoryTokens: ["cat_food-snacks"],
  tags: ["candles", "home fragrance", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
